import { ReactComponent as CheckSVG } from "./svg/icon_check.svg";
import "./IconCheck.scss";

interface IconCheckProps extends React.ComponentProps<"img"> {
  color?: "green" | "gray" | "orange" | "blue";
  id?: string;
  withStroke?: boolean;
}

export const IconCheck = ({ color = "green", id = "", withStroke = false }: IconCheckProps) => {
  const className = `icon-check--${color}${withStroke ? "WithStroke" : ""}`;

  return (
    <span id={id} className={`icon-check ${className}`}>
      <CheckSVG />
    </span>
  );
};
